let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dmjTp")).then(() => parcelRequire('2V4fk'));